<template>
  <div class="FormContactRtb" id="contact-form">
    <Wrap class="md">
      <FormValidation v-if="!hasSent" @submit="send">
        <validation-observer ref="formObs" tag="div">
          <div>
            <Row>
              <Column :lg="6">
                <Field
                  autocomplete="fname"
                  :label="$t('firstName')"
                  :maxLength="50"
                  required
                  :value.sync="firstName" />
              </Column>
              <Column :lg="6">
                <Field
                  autocomplete="lname"
                  :label="$t('lastName')"
                  :maxLength="50"
                  required
                  :value.sync="lastName" />
              </Column>
            </Row>
            <Row>
              <Column :lg="6">
                <Field
                  autocomplete="email"
                  :label="$t('email')"
                  :maxLength="130"
                  rules="email"
                  type="email"
                  required
                  :value.sync="contact.email" />
              </Column>
              <Column :lg="6">
                <Field
                  autocomplete="phone"
                  :label="$t('phone')"
                  :maxLength="50"
                  required
                  :value.sync="contact.phone" />
              </Column>
            </Row>
            <Field
              class="textarea"
              type="textarea"
              :maxlength="1000"
              :label="$t('additionalQuestion')"
              :value.sync="contact.message" />
          </div>
          <div class="checkboxes">
            <Row>
              <Column :md="8">
                <NoticeRecaptcha />
                <FieldConsent :value.sync="contact.hasAcceptedPolicy" />
              </Column>
              <Column class="submit-column" :md="4">
                <Btn type="submit" :isLoading="isSending">
                  {{ $t('send') }}
                </Btn>
              </Column>
            </Row>
          </div>
        </validation-observer>
      </FormValidation>
      <Notice v-if="hasSent && message" :class="message.theme">
        {{ message.text }}
      </Notice>
    </Wrap>
  </div>
</template>

<script>
import { actions, getters } from 'views/utils'
import Message from 'views/mixins/Message'
import NoticeRecaptcha from 'views/components/NoticeRecaptcha'
import { isMock } from '../../../../config'
import { softThrow } from '../../../../bugsnag'

export default {
  mixins: [Message],
  components: { NoticeRecaptcha },
  data() {
    return {
      contact: this.$store.getters.contactFactory(),
      firstName: '',
      lastName: '',
      isSending: false,
      hasSent: false,
    }
  },
  computed: {
    fullName() {
      return `${this.firstName} ${this.lastName}`
    },
    ...getters(),
  },
  methods: {
    async send() {
      try {
        this.isSending = true

        if (!isMock) {
          const recaptcha = await this.$recaptchaToken('contact')
          await this.CREATE_CONTACT({
            ...this.contact,
            name: this.fullName,
            recaptcha,
          })
        }
        this.hasSent = true
        this.$analytics.fbq.event('Lead')
        this.success(this.$t('success'))
      } catch (error) {
        error.body = this.contact
        softThrow(error)
        this.ERROR(error)
      } finally {
        this.isSending = false
      }
    },
    ...actions('CREATE_CONTACT'),
  },
}
</script>

<style lang="scss">
.FormContactRtb {
  background-color: $grey-lighter;
  // margin: 2rem 0 0;
  padding: 3rem 2rem 0;

  textarea {
    min-height: 80px;
  }

  .checkboxes {
    margin-top: 0.5rem;
    text-align: left;

    @include md {
      margin-top: 0;
    }
  }

  form {
    @include lg {
      margin-top: 3rem;
    }

    input,
    select,
    textarea {
      text-align: left;
      text-align-last: left;
    }

    .checkboxes {
      .Field-errors {
        margin-bottom: 1rem;
      }

      .submit-column {
        text-align: center;

        @include md {
          text-align: right;
        }
      }
    }

    .Btn {
      margin: auto;
      max-width: 20rem;
      min-width: 9rem;
      padding: 1.25rem 0;
      width: 100%;

      @include sm {
        width: auto;
      }
    }
  }

  .Notice {
    margin-top: 2rem;
  }
}
</style>

<i18n>
{
  "pl": {
    "email": "Email",
    "message": "Twoja wiadomość",
    "firstName": "Imię",
    "lastName": "Nazwisko",
    "phone": "Numer telefonu",
    "send": "Wyślij",
    "additionalQuestion": "Wiadomość",
    "success": "Dziękujemy, wkrótce się z Tobą skontaktujemy."
  }
}
</i18n>
